module.exports = __webpack_public_path__ + "static/media/feeling-good3.35c6bfbc.svg";